import React, { createContext, useContext, useState } from 'react';

const PermisosContext = createContext([]);

export const PermisosProvider = ({ children }) => {
  const [permisos, setPermisos] = useState([]); // inicializa como un array vacío

  return (
    <PermisosContext.Provider value={{ permisos, setPermisos }}>
      {children}
    </PermisosContext.Provider>
  );
};

export const usePermisos = () => {
  const { permisos } = useContext(PermisosContext);
  return permisos || []; // siempre devuelve un array
};